import { render, staticRenderFns } from "./dialogRescheduleTest.vue?vue&type=template&id=2bdd49a0&scoped=true"
import script from "./dialogRescheduleTest.vue?vue&type=script&lang=js"
export * from "./dialogRescheduleTest.vue?vue&type=script&lang=js"
import style0 from "./dialogRescheduleTest.vue?vue&type=style&index=0&id=2bdd49a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd49a0",
  null
  
)

export default component.exports